global.Buffer = global.Buffer || require("buffer").Buffer;

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mixin from "./mixin";
import Axios from "axios";
import VueRouter from "vue-router";
import "./../public/tailwind.css";
import VueSweetalert2 from "vue-sweetalert2";

import "sweetalert2/dist/sweetalert2.min.css";

// Configure SweetAlert2
const swalOptions = {
  allowEscapeKey: true,
  customClass: {
    container: "swal2-container-custom",
  },
};

Vue.use(VueSweetalert2, swalOptions);

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.mixin(mixin);

console.log("VUE_APP_URLAPP", process.env.VUE_APP_URLAPP);

Axios.defaults.baseURL = process.env.VUE_APP_URLAPP;
Axios.interceptors.request.use(
  async (config) => {
    config.timeout = 30000;
    config.timeoutErrorMessage = "Time Out";
    const token = store.get("token");
    if (!config.headers) {
      config.headers = [];
    }
    if (!config.headers["Content-type"] && !(config.data instanceof FormData)) {
      config.headers["Content-type"] = "application/json";
    }
    if (!config.headers["Authorization"] && token) {
      config.headers["Authorization"] = `${token}`;
    }
    const selectedSchoolId = localStorage.getItem("selected_school_id");
    if (selectedSchoolId) {
      config.headers["X-School-Id"] = selectedSchoolId;
    }
    return config;
  },
  (error) => {
    return Promise.reject("request", error);
  },
);

Axios.interceptors.response.use(
  (response) => {
    console.log("INTERCEPTORS RESPONSE", response);
    if (response.status == 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response);
    }
  },
  async (error) => {
    const currentPath = router.currentRoute ? router.currentRoute.path : "";
    const isPublicRoute =
      currentPath.startsWith("/public-register") ||
      currentPath.startsWith("/login") ||
      currentPath.startsWith("/student/login") ||
      currentPath.startsWith("/teacher/login") ||
      (window.location.hash &&
        window.location.hash.includes("public-register")) ||
      (window.location.pathname &&
        window.location.pathname.includes("public-register")) ||
      (error.config &&
        error.config.url &&
        (error.config.url.includes("publicregister") ||
          error.config.url.includes("province") ||
          error.config.url.includes("district") ||
          error.config.url.includes("village") ||
          error.config.url.includes("ethnic"))) ||
      (router.currentRoute &&
        router.currentRoute.matched &&
        router.currentRoute.matched.length > 0 &&
        !router.currentRoute.matched.some(
          (record) => record.meta && record.meta.requiresAuth
        ));

    if (
      (error.message.includes("status code 400") ||
        error.message.includes("status code 401")) &&
      !isPublicRoute
    ) {
      store.set("user", null);
      console.log(router.currentRoute.path);
      if (
        router.currentRoute.path.includes("/student") ||
        router.currentRoute.path.includes("/teacher")
      ) {
        router.replace({ path: "/student/login" });
      } else {
        router.replace({ path: "/login" });
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
